
export default {
  salesForecastPosting: false,
  salesForecastErrors: [],
  salesForecastTotals: 0,
  salesForecastPosted: 0,
  
  mainListQuickFilters: [],
  quickFiltersDatesFrom: [],
  quickFiltersDatesTo: [],
}